import { render } from "./CmsAccordion.vue?vue&type=template&id=c98909ec"
import script from "./CmsAccordion.vue?vue&type=script&lang=js"
export * from "./CmsAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__